"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkSwatchPanel = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("@jsonjoy.com/ui/lib/4-card/Popup/context");
const ContextMenu_1 = require("@jsonjoy.com/ui/lib/4-card/ContextMenu");
const ColorSwatch_1 = require("@jsonjoy.com/ui/lib/2-inline-block/ColorSwatch");
const context_2 = require("@jsonjoy.com/ui/lib/styles/context");
const palette_1 = require("../util/palette");
const color_1 = require("../behavior/color");
const RecentMarkIcon = ({ slot }) => {
    const styles = (0, context_2.useStyles)();
    const dark = !styles.light;
    return React.createElement(ColorSwatch_1.ColorSwatch, { kind: "plain", size: 20, color: (0, palette_1.markSlotBg)(slot, dark), textColor: (0, palette_1.markSlotFg)(slot, dark) });
};
/** Builds a recents-menu item that re-applies a specific highlight slot. */
const buildRecentMarkItem = (slot, mutxt) => ({
    id: 'recent-mark-' + slot,
    name: palette_1.MARK_SLOT_LABEL[slot] + ' highlight',
    text: 'mark highlight ' + palette_1.MARK_SLOT_LABEL[slot] + ' background color',
    icon: () => React.createElement(RecentMarkIcon, { slot: slot }),
    onSelect: () => {
        (0, color_1.setMarkColor)(mutxt.editor, slot);
        mutxt.sync(false);
    },
});
const containerClass = (0, nano_theme_1.rule)({
    d: 'flex',
    fld: 'row',
    ai: 'center',
    gap: '4px',
    pd: '8px',
});
const MarkSwatchPanel = ({ mutxt }) => {
    const popup = (0, context_1.usePopup)();
    const styles = (0, context_2.useStyles)();
    const dark = !styles.light;
    mutxt.version.use();
    React.useEffect(() => {
        mutxt.inline.setPopupOpen(true);
        return () => mutxt.inline.setPopupOpen(false);
    }, [mutxt]);
    const current = (0, color_1.getActiveMarkColor)(mutxt.editor);
    const activeSlot = current === true ? 'yellow' : current;
    const apply = (slot) => {
        const isToggleOff = slot === activeSlot;
        (0, color_1.setMarkColor)(mutxt.editor, isToggleOff ? undefined : slot);
        mutxt.sync(false);
        if (!isToggleOff)
            mutxt.inline.menu.addRecent(buildRecentMarkItem(slot, mutxt));
        popup?.close();
    };
    const preventMouseDown = (e) => e.preventDefault();
    return (React.createElement(ContextMenu_1.ContextPane, null,
        React.createElement("div", { className: containerClass, onMouseDown: preventMouseDown }, palette_1.MARK_SLOTS.map((slot) => (React.createElement(ColorSwatch_1.ColorSwatch, { key: slot, kind: "plain", size: 24, color: (0, palette_1.markSlotBg)(slot, dark), textColor: (0, palette_1.markSlotFg)(slot, dark), active: slot === activeSlot, tooltip: { renderTooltip: () => palette_1.MARK_SLOT_LABEL[slot] }, onClick: () => apply(slot) }))))));
};
exports.MarkSwatchPanel = MarkSwatchPanel;
